import RepositoryService from 'src/services/repository'

const resource = 'batch'

export default {
  ...RepositoryService.utils.createCrudRepository(resource),
  closeOperation: params => RepositoryService.base.post(`${resource}/${params.batchId}/close-operation/${params.operationBatchId}`),
  openOperation: params => RepositoryService.base.post(`${resource}/${params.batchId}/open-operation/${params.operationBatchId}`),
}
